const msgError = `Insira um valor válido para amount. \n\n
  Exemplo: \n
    - amount: "10.00" é equivalente à R$ 10,00.
    - amount: "150.01" é equivalente à R$ 150,01.
    - amount: "1500.55" é equivalente à R$ 1.500,55.`;

const isValidAmount = numberStr => !(isNaN(numberStr) || numberStr <= 0
  || (numberStr.indexOf('.') !== -1 && numberStr.split('.')[1].length !== 2)
  || numberStr.indexOf('.') === -1);

const format = amount =>
  amount.toFixed(2).replace('.', ',').replace(/(d)(?=(d{3})+,)/g, '$1.');

export default function handleAmount(amountStr) {
  if (!isValidAmount(amountStr)) {
    /* eslint-disable */
    console.error(msgError);
    /* eslint-disable */
    return false;
  }
  return format(Number(amountStr));
};



// WEBPACK FOOTER //
// ./src/handle-amount.js